import React, { useState } from 'react';

import EditableText from 'components/Inputs/EditableText';

import { useCategoryContext } from 'components/CategoryList/CategoryContext';
import { IdsByApp } from 'generated/graphql';
import styles from './EditableDescription.module.scss';

type Props = {
  description: string | undefined | null;
  idsByApp: IdsByApp[];
};
const noDescriptionText = '+ Add Description';
const EditableDescription: React.FC<Props> = ({ description, idsByApp }) => {
  const { updateCategory } = useCategoryContext();

  const updateDescription = (text: string): void => {
    if (text.trim() === '') updateCategory({ description: ' ', idsByApp });
    else updateCategory({ description: text.trim(), idsByApp });
  };

  const [text, setText] = useState<string>(description?.trim() || noDescriptionText);

  const noText = text === noDescriptionText;

  const handleFocusOrBlur = (type: 'focus' | 'blur' | 'enter'): void => {
    if (type === 'focus') {
      setText(description?.trim() || '');
      return;
    }
    updateDescription(text);
    setText((prev) => (prev.trim() === '' ? noDescriptionText : prev));
  };

  return (
    <div className={styles.Outer}>
      <h3 className={noText ? '' : styles.lightweight}>
        <EditableText
          text={text}
          placeholder="Description"
          onStateChange={handleFocusOrBlur}
          onSubmit={setText}
          buttonStyle={noText ? styles.bigButton : ''}
          hidePencil={noText}
        />
      </h3>
    </div>
  );
};

export default EditableDescription;
